import { render } from "./ViewPdf.vue?vue&type=template&id=c209922e"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\autfis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__